<template>
  <div
    ref="thumbsContainer"
    class="thumbs-container"
    v-if="groupList.length > 1 || sceneList.length > 1"
    :class="[showThumbs == true ? 'containerSlideIn' : 'containerSlideOut']"
  >
    <!--    :class="[isMenu?'hasMenu':'',showThumbs==true?'containerSlideIn':'containerSlideOut']"-->
    <div ref="sceneContainer" class="thumb-sceneContainer slideIn">
      <div>
        <div class="swiper-container" id="myswiper01">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, idx) in sceneList"
              :key="idx"
              :class="item.id == currentScene ? 'active' : ''"
            >
              <div @click="gotoScene(item.id)">
                <img :src="item.thumb_path" />
                <!-- <div class="thumb_name" :title="item.name">{{ item.name }}</div> -->
                <div class="marquee-block" :title="item.name">
                  <div class="marquee-item">
                    <span
                      v-show="item.name.length>4"
                      :class="
                        item.id == currentScene
                          ? 'marqueeName'
                          : 'default-marqueeName'
                      "
                      class="default-marqueeName-mobile"
                    >
                      {{ item.name }}
                    </span>
                    <span
                      v-show="item.name.length <= 4"
                      class="default-marqueeName-mobile"
                    >
                      {{ item.name }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      ref="groupContainer"
      class="thumb-groupContainer"
      v-if="groupList.length > 1"
    >
      <div>
        <div class="swiper-container" id="myswiper02">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, idx) in groupList"
              :key="idx"
              :class="item.id == currentGroup ? 'active' : ''"
            >
              <div class="name-con" @click="switchGroup(idx)">
                <div class="group-names" :title="item.name">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import { mapGetters } from "vuex";

export default {
  props: {
    //krpano對象，
    krpanoObj: {
      // type: Object | Element,
      default: null,
    },
    groupList: {
      type: Array,
      default: () => [],
    },
    isPano3d: {
      type: Boolean,
      default: false,
    },
    /*isMenu:{
        type: Boolean,
        default: false
    }*/
  },
  // components: { Swiper, SwiperSlide },
  data() {
    return {
      //是否顯示縮略圖容器
      showThumbs: true,
      sceneList: [],
      currentScene: null,
      currentGroup: null,
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 0, //slider間距已經在css中定義
        breakpoints: {
          1024: {
            slidesPerView: "auto",
            spaceBetween: 0,
          },
          768: {
            slidesPerView: "auto",
            spaceBetween: 0,
          },
          640: {
            slidesPerView: "auto",
            spaceBetween: 0,
          },
          320: {
            slidesPerView: "auto",
            spaceBetween: 0,
          },
        },
      },
      mySwiper01: undefined,
    };
  },
  computed: {
    /*
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    swiperGroup() {
      return this.$refs.mySwiperGroup.$swiper;
    },
    */
  },
  // 離線版使用created拿取父組件的this.groupList資料
  created() {
    if (this.groupList.length > 0) {
          this.currentGroup = this.groupList[0].id;
          this.sceneList = this.groupList[0].sceneList;
          if (this.sceneList.length > 0) {
            this.$nextTick(() => {
              this.initCustomSwiper();
            });
          }
      }
  },

  mounted() {
    //console.log('Current Swiper instance object', this.swiper);
    //this.swiper.slideTo(3, 1000, false)
  },

  methods: {
    initCustomSwiper() {
      if (!this.mySwiper01) {
        this.mySwiper01 = new Swiper("#myswiper01", {
          direction: "horizontal", // 垂直切換選項
          slidesPerView: "auto",
          spaceBetween: 0, //slider間距已經在css中定義
          observer: true,
          observeParents: true,

          breakpoints: {
            1024: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
            768: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
            640: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
            320: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
          },
        });
        var mySwiper02 = new Swiper("#myswiper02", {
          slidesPerView: "auto",
          spaceBetween: 0, //slider間距已經在css中定義
          observer: true,
          observeParents: true,
          centeredSlides: false,
          spaceBetween: 0, //slider間距已經在css中定義
          breakpoints: {
            1024: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
            768: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
            640: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
            320: {
              slidesPerView: "auto",
              spaceBetween: 0,
            },
          },
        });
      }
    },
    switchGroup: function (idx) {
      let _this = this;
      this.$refs.sceneContainer.className = "thumb-sceneContainer slideOut";
      setTimeout(function () {
        _this.$refs.sceneContainer.className = "thumb-sceneContainer slideIn";
        _this.currentGroup = _this.groupList[idx].id;
        _this.sceneList = _this.groupList[idx].sceneList;
        console.log("_this.sceneList==", _this.sceneList);

      }, 200);

    },
    gotoScene: function (sceneId) {
      this.$emit('showPano3d', false);
      let currQuery = this.$route.query
      this.$router.replace({ path: this.$route.path, query: {...currQuery, scene: sceneId} });
      this.$parent.wxInit();
      this.krpanoObj.call(
        "loadscene(" + sceneId + ", null, MERGE, BLEND(0.5));"
      );
    },
  },
  //監聽異步數據 (在作品管理直接打開作品使用watch)
  watch: {
    groupList: {
      handler() {
        if (this.groupList.length > 0) {
          this.currentGroup = this.groupList[0].id;
          this.sceneList = this.groupList[0].sceneList;
          if (this.sceneList.length > 0) {
            this.$nextTick(() => {
              this.initCustomSwiper();
            });
          }
        }
      },
      deep: true,
    },
    krpanoObj: {
      handler() {
        //todo
      },
    },
    currentScene(val, preVal) {
      //循環分組
      if (val != preVal && this.groupList.length > 1) {
        for (let i = 0; i < this.groupList.length; i++) {
          let rowscene = this.groupList[i].sceneList;
          for (let i2 = 0; i2 < rowscene.length; i2++) {
            if (val == rowscene[i2].id) {
              if (this.currentGroup != this.groupList[i].id) {
                this.switchGroup(i);
              }
              break;
            }
          }
        }
      }
    },
  },
};
</script>

<style>
/* 設置全局的滾動區域自動內容寬度，不自動佔滿屏，不然無法居中 */
.swiper-wrapper {
  width: -moz-fit-content;
  width: -webkit-fit-content;
  width: fit-content;
  margin: 0 auto;
}
.thumbs-container {
  position: absolute;
  width: 100%;
  bottom: 100px;
  z-index: 700;
  /*-webkit-transition: 0.2s ease-in;
  -moz-transition: 0.2s ease-in;
  -ms-transition: 0.2s ease-in;
  -o-transition: 0.2s ease-in;
  transition: 0.2s ease-in;*/
}
.thumb_name {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  overflow: hidden;
  white-space: nowrap;
  color: #fff;
}
.marquee-block {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
.marquee-item {
  margin: 0 5px;
  overflow: hidden;
  white-space: nowrap;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}
.marqueeName {
  display: inline-block;
  animation: marqueeNameName 5s linear infinite;
}
.default-marqueeName {
  display: inline-block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@keyframes marqueeNameName {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
.thumb-sceneContainer {
  background: rgba(0, 0, 0, 0.4);
  overflow: hidden;
}
.thumb-groupContainer {
  background: rgba(0, 0, 0, 0.4);
}
.thumb-sceneContainer > div,
.thumb-groupContainer > div {
  padding: 5px;
}
</style>
<style lang="less">
.thumb-sceneContainer .swiper-wrapper {
  .swiper-slide {
    width: 84px;
    height: 84px;
    position: relative;
    text-align: center;
    background: #333;
    border: 2px solid #fff;
    cursor: pointer;
    margin-left: 5px;
    margin-right: 5px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .swiper-slide {
    /*height: 400px;*/
    /*background-color: #1890ff;*/
    cursor: pointer;
    /*border: 2px solid #ffffff;*/
    &:hover {
      /*box-shadow: 0 0 12px 3px rgba(0,0,0,.03);*/
      /*border: 2px solid #1890ff;*/
    }
    img {
      max-width: 100%;
    }
  }

  .active {
    border: 2px solid #ff6600;
  }
}
.thumb-groupContainer {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
.thumb-groupContainer .swiper-wrapper {
  .swiper-slide {
    width: 100px;
    height: 100%;
    padding: 0 10px;
  }
  .name-con {
    height: 100%;
    width: 100%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    color: #ffffff;
  }
  .active .name-con {
    border-bottom: 2px solid #ff6600;
  }
}
@media screen {
  @media (max-width: 768px) {
    .thumb-sceneContainer .swiper-wrapper {
      .swiper-slide {
        width: 64px;
        height: 64px;
      }
    }

    .thumb_name {
      font-size: 12px;
    }
    .default-marqueeName-mobile{
      font-size: 12px;
    }
  }
}
.slideOut {
  -webkit-transition: 0.2s ease-in;
  -moz-transition: 0.2s ease-in;
  -ms-transition: 0.2s ease-in;
  -o-transition: 0.2s ease-in;
  transition: 0.2s ease-in;
  height: 0;
}
.slideIn {
  -webkit-transition: 0.2s ease-in;
  -moz-transition: 0.2s ease-in;
  -ms-transition: 0.2s ease-in;
  -o-transition: 0.2s ease-in;
  transition: 0.2s ease-in;
  height: 94px;
}
.containerSlideOut {
  -webkit-transition: 0.2s ease-in;
  -moz-transition: 0.2s ease-in;
  -ms-transition: 0.2s ease-in;
  -o-transition: 0.2s ease-in;
  transition: 0.2s ease-in;
  bottom: -200px;
}
.containerSlideIn {
  -webkit-transition: 0.2s ease-in;
  -moz-transition: 0.2s ease-in;
  -ms-transition: 0.2s ease-in;
  -o-transition: 0.2s ease-in;
  transition: 0.2s ease-in;
  bottom: 100px;
}
@media screen {
  @media (max-width: 768px) {
    .slideIn {
      height: 74px;
    }
    .containerSlideOut {
      bottom: -150px;
    }
    .containerSlideIn {
      bottom: 70px;
    }
    /*.hasMenu.containerSlideIn{
        bottom: 113px;
    }*/
  }
}
</style>

